import React, { useState } from 'react'
import styled from 'styled-components'
import Card from '@taglivros/oef_componentes/build/components/card'
import Button from '@taglivros/oef_componentes/build/components/button'
import ReactPixel from 'react-facebook-pixel'
import { QUERO_MGM, EVENTOS_PIXEL } from '../../../containers/Opcionais/constantsCardOpcionais'
import ModalMgm from '../../../components/ModalMgm/ModalMgm'
import { useGlobal } from '../../../contexts/GlobalContext'
import { useOpcionais } from '../../../contexts/OpcionaisContext'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'


const Container = styled.div`
  .card {
    padding: 30px;
    @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
      padding: 20px;
    }
  }
`

const Texto = styled.h3`
`

const BookTitleWrapper = styled.div`
  display: flex;
  padding-bottom: 30px;
  gap: 25px;
  align-items: center;
  justify-content: center;
  img {
    height: 115px;
  }
  @media (min-width: 520px) {
    img {
      height: 80px;
    }
    h3 {
      font-size: 14px;
    }
  }

  @media (min-width: 680px) {
    img {
      height: 115px;
    }
    h3 {
      font-size: 14px;
    }
  }

  h1 {
    display: flex;
    align-items: center;
    font-size: 24px;
  }

  @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
    h1 {
      font-size: 16px;
    }
  }
`

const ButtonWrapper = styled.div`
  button {
    width: 100%;
    padding: 15px 30px;
  }
`

const CardIndicate = () => {
  const [ showModal, setShowModal ] = useState( false )
  const { dadosGlobaisAssociado } = useGlobal()
  const { dadosOpcionais } = useOpcionais()
  return (
    <Container id="mgm">
      <Card
        className="card"
        largura="100%"
        margin="0"
        paddin="0"
      >
        <BookTitleWrapper>
          <img
            alt={ `Capa ${dadosOpcionais?.mgm?.texto}` }
            height="115px"
            src={ dadosOpcionais?.mgm?.imagem }
            width="115px"
          />

          <Texto>{`${dadosOpcionais?.mgm?.texto}`}</Texto>
        </BookTitleWrapper>

        <ButtonWrapper>
          <Button
            invertido={ true }
            onClick={ () => {
              ReactPixel.trackCustom( EVENTOS_PIXEL.QUERO_INDICAR )
              setShowModal( !showModal )
            } }
            testId="botao-mgm"
          >
            { QUERO_MGM }
          </Button>
        </ButtonWrapper>
      </Card>

      <ModalMgm
        codigoIndicacao={ dadosGlobaisAssociado.associado.codigoIndicacao }
        showModal={ showModal }
        toggleModal={ () => setShowModal( !showModal ) }
      />
    </Container>
  )
}

export default CardIndicate
